import { Control, FieldErrors } from "react-hook-form"
import { FormInput } from "@/shared/ui/form-input"
import { AclStrategy } from "@/shared/api/groups"
import { ACL_STRATEGY_OPTIONS } from "../config"
import { GroupBase, OptionsOrGroups } from "react-select"
import { FormEventHandler } from "react"

export interface VisibilityAclFormValues {
    acl_strategy?: AclStrategy
    visible_group_ids?: string[] | null
}

interface VisibilityAclFormProps {
    control: Control<VisibilityAclFormValues>
    errors: FieldErrors<VisibilityAclFormValues>
    isSubmitting: boolean
    onSubmit: FormEventHandler<HTMLFormElement>
    onCancel: () => void
    visibleGroupsSelectOptions: OptionsOrGroups<{ value: string; label: string }, GroupBase<{ value: string; label: string }>>
    /** Show ACL strategy select. False for user ACL modal. */
    showStrategySelect?: boolean
    /** Show visible groups select. False when strategy is inherit-only (group modal). */
    showVisibleGroupsSelect?: boolean
}

export const VisibilityAclForm = ({
    control,
    errors,
    isSubmitting,
    onSubmit,
    onCancel,
    visibleGroupsSelectOptions,
    showStrategySelect = true,
    showVisibleGroupsSelect = true,
}: VisibilityAclFormProps) => (
    <form onSubmit={onSubmit} className="flex flex-col gap-3 border-b pb-4">
        <h3 className="text-lg font-semibold">Создать новый ACL</h3>
        {showStrategySelect && (
            <FormInput
                label="Стратегия ACL"
                id="acl_strategy"
                options={ACL_STRATEGY_OPTIONS}
                control={control}
                error={errors.acl_strategy}
                type="select"
                required={false}
                placeholder="Выберите стратегию"
            />
        )}
        {showVisibleGroupsSelect && (
            <FormInput
                label="Видимые группы"
                id="visible_group_ids"
                options={visibleGroupsSelectOptions}
                control={control}
                error={errors.visible_group_ids?.[0]}
                type="select"
                isMulti={true}
                required={false}
                placeholder="Выберите видимые группы"
            />
        )}
        <div className="w-full flex gap-3">
            <button onClick={onCancel} className="form_cancel_button" type="button">
                Отменить
            </button>
            <button disabled={isSubmitting} className="form_handle_button" type="submit">
                Создать
            </button>
        </div>
    </form>
)
